import { createForegroundLoadingController } from "@shared/foregroundLoading";

export const foregroundLoading = createForegroundLoadingController();
